import React, { Component, lazy, Suspense } from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { ConnectedRouter } from 'connected-react-router';
import ReactGA from 'react-ga';
import * as actions from 'Actions';
import SignUp from 'Containers/authentication/SignUp';
import ReactivateBusiness from 'Containers/authentication/ReactivateBusiness';
import SelectBusiness from 'Containers/authentication/SelectBusiness';
import ConversationsMiddle from 'Components/conversations/ConversationsMiddle';
import ProfileMiddle from 'Components/profile/ProfileMiddle';
import Footer from 'Components/marketing/Footer';
import Authorization, {
  AuthAllButWarehouse,
  AuthGeneral,
} from 'Containers/authentication/Authorization';
import BusinessAuthorization from 'Containers/authentication/BusinessAuthorization';
import OverlayLoadingSpinner from 'Utils/OverlayLoadingSpinner';
import NotFound from 'Utils/NotFound';
import ApplicationError from 'Utils/ApplicationError';
import CompliancePopUp from 'Utils/CompliancePopUp';
import SystemUpdateWidget from 'Utils/global/SystemUpdateWidget';
import Helmets from 'Utils/Helmets';
import RouteChangeWrapper from 'Utils/RouteChangeWrapper';
import UnsupportedRoute from 'Utils/UnsupportedRoute';
import MockPage from 'Utils/MockPage';
import { isSupportedBrowser } from 'HelperFunctions/general';
import App from './App';
import Home from './marketing/Home';
import HelpForm from './marketing/HelpForm';
import PrintMiddle from './print/PrintMiddle';
import Email from './emails/Email';
import NewFeedback from './feedbacks/NewFeedback';
import FeedbackThankYou from './feedbacks/FeedbackThankYou';
import ContactUs from './marketing/ContactUs';
import TopHeader from 'Utils/global/TopHeader';
import { connect } from 'react-redux';
import { logOutAfterOtherTabSignIn } from 'Actions';
import { ADMIN_ONLY_ROLES } from 'Utils/AtAGlanceLink';
import ImportWizardUpload from './import_wizard/Upload';
import ImportWizardAdjust from './import_wizard/Adjust';
import ImportWizardSelect from './import_wizard/ImportWizardSelect';
import ImportWizardDone from './import_wizard/Done';
import ImportWizardPreview from './import_wizard/Preview';
import ImportWizardDreamUpload from './import_wizard/DreamUpload';
import ImportWizardTranslate from './import_wizard/Translate';
import ProductMultilocation from './products/ProductMultilocation';
import { history } from './utils/router/history';
import LoadingSpinner from 'Utils/LoadingSpinner';

const SignIn = lazy(() => import('Containers/authentication/SignIn'));
const BusinessPaymentPage = lazy(
  () => import('Components/transactions/BusinessPaymentPage')
);
const BusinessPaymentStatusPage = lazy(
  () => import('Components/transactions/BusinessPaymentStatusPage')
);
const ForgotPassword = lazy(
  () => import('Containers/authentication/ForgotPassword')
);
const PasswordReset = lazy(
  () => import('Containers/authentication/PasswordReset')
);
const SignUpMiddle = lazy(() => import('Components/signup/SignUpMiddle'));
const Dashboard = lazy(() => import('Components/dashboard/Dashboard'));
const Tutorials = lazy(() => import('Components/tutorials/Tutorials'));
const Notifications = lazy(
  () => import('Components/notifications/Notifications')
);
const ChurnZeroSuccessCenter = lazy(
  () => import('Components/churn_zero/ChurnZeroSuccessCenter')
);
const AtAGlance = lazy(() => import('Components/dashboard/AtAGlance'));
const Payments = lazy(() => import('Components/payments/PaymentsMiddle'));
const Events = lazy(() => import('Components/events/EventsRoutes'));
const Inventory = lazy(() => import('Components/products/Inventory'));
const Contacts = lazy(() => import('Components/contacts/Contacts'));

const Operations = lazy(() => import('Components/operations/Operations'));
const Staff = lazy(() => import('Components/staff/Staff'));
const Services = lazy(() => import('Components/services/Services'));

const BusinessAdmin = lazy(
  () => import('Components/business_admin/BusinessAdmin')
);
const Admin = lazy(() => import('Components/admin/Admin'));

const Calendars = lazy(() => import('Components/calendars/CalendarContainer'));
const Recurrences = lazy(() => import('Components/recurrences/Recurrences'));
const Upgrade = lazy(() => import('Components/upgrade/Upgrade'));

ReactGA.initialize(import.meta.env.VITE_GA_TRACKING_ID);

function logPageView() {
  ReactGA.set({ page: window.location.pathname + window.location.search });
  ReactGA.pageview(window.location.pathname + window.location.search);
}

const AuthFeedback = AuthAllButWarehouse(NewFeedback);

const AuthAdminOnly = Authorization(ADMIN_ONLY_ROLES);

export const AuthStandardTier = BusinessAuthorization(['all']);
export const AuthServiceTier = BusinessAuthorization(['services']);

history.listen(() => {
  logPageView();
});

const routesWithSystemUpdateWidget = [
  '/dashboard',
  '/todos',
  '/payments',
  '/conversations',
  '/profile',
  '/operations',
  '/services',
  '/calendars',
  '/contacts',
  '/inventory',
  '/orders',
  '/parent-orders',
  '/admin',
];
const routesWithCompliancePopUp = [
  '/dashboard',
  '/todos',
  '/payments',
  '/conversations',
  '/profile',
  '/operations',
  '/services',
  '/calendars',
  '/contacts',
  '/inventory',
  '/orders',
  '/parent-orders',
  '/admin',
];

const routesWithFooter = [
  '/feedbacks',
  '/test',
  '/login',
  '/forgotPassword',
  '/passwordReset',
  '/selectBusiness',
  '/signUp',
  '/start',
  '/support',
  '/contact',
  '/notFound',
  '/parent-orders',
  '/applicationError',
];

class Routes extends Component {
  constructor(props) {
    super(props);
  }
  UNSAFE_componentWillMount() {
    this.restoreInfoFromLocal();
  }

  restoreInfoFromLocal = () => {
    const { store } = this.props;
    const tileView = localStorage.getItem('tileView') || 'false';
    const itemNotesView = localStorage.getItem('itemNotesView') || 'false';

    if (tileView === 'false') {
      store.dispatch(actions.hideTiles());
    } else {
      store.dispatch(actions.showTiles());
    }

    if (itemNotesView === 'false') {
      store.dispatch(actions.hideItemNotes());
    } else {
      store.dispatch(actions.showItemNotes());
    }
  };
  localStorageUpdated = () => {
    const { store, user } = this.props;
    if (user && user.uid) {
      const authTokenHeaders = JSON.parse(
        localStorage.getItem('authTokenHeaders')
      );
      if (authTokenHeaders && user.uid !== authTokenHeaders.uid) {
        store.dispatch(logOutAfterOtherTabSignIn());
        history.push({
          pathname: '/login',
        });
      }
    }
  };
  componentDidMount() {
    if (typeof window !== 'undefined') {
      window.addEventListener('storage', this.localStorageUpdated);
    }
  }

  render() {
    const { shouldShowAlertTrial } = this.props;
    const SupportPage = AuthGeneral(HelpForm);
    const DashboardPage = AuthGeneral(Dashboard);
    const TutorialsPage = AuthGeneral(Tutorials);
    const NotificationsPage = AuthGeneral(Notifications);
    const ChurnZeroSuccessCenterPage = AuthGeneral(ChurnZeroSuccessCenter);
    const ImportWizardUploadPage = AuthGeneral(ImportWizardUpload);
    const ImportWizardAdjustPage = AuthGeneral(ImportWizardAdjust);
    const ImportWizardDonePage = AuthGeneral(ImportWizardDone);
    const ImportWizardPreviewPage = AuthGeneral(ImportWizardPreview);
    const ImportWizardSelectPage = AuthGeneral(ImportWizardSelect);
    const ImportWizardDreamUploadPage = AuthGeneral(ImportWizardDreamUpload);
    const ImportWizardTranslatePage = AuthGeneral(ImportWizardTranslate);
    const AtAGlancePage = AuthAdminOnly(AtAGlance);
    const PaymentsPage = AuthGeneral(Payments);
    const UpgradePage = AuthGeneral(Upgrade);
    const OperationsPage = AuthGeneral(AuthStandardTier(Operations));
    const StaffPage = AuthGeneral(AuthServiceTier(Staff));
    const ServicesPage = AuthGeneral(AuthServiceTier(Services));
    const RecurrencesPage = AuthGeneral(AuthServiceTier(Recurrences));
    const CalendarsPage = AuthGeneral(AuthServiceTier(Calendars));
    const InventoryPage = AuthGeneral(AuthStandardTier(Inventory));
    const EventsPage = AuthGeneral(Events);
    const PrintMiddlePage = AuthGeneral(PrintMiddle);
    const ProductMultilocationPage = AuthGeneral(ProductMultilocation);

    if (!isSupportedBrowser()) {
      return <UnsupportedRoute history={history} />;
    }
    return (
      <ConnectedRouter history={history}>
        <RouteChangeWrapper>
          <div className='container'>
            <Route path='/' component={App} />
            <header>
              <TopHeader />
              {routesWithSystemUpdateWidget.map((path, i) => (
                <Route
                  key={`sytstem-update-${path}`}
                  path={path}
                  render={(props) => <SystemUpdateWidget {...props} />}
                />
              ))}
              {routesWithCompliancePopUp.map((path, i) => (
                <Route
                  key={`compliance-popu-${path}`}
                  path={path}
                  render={(props) => <CompliancePopUp {...props} />}
                />
              ))}
              <Route path='/' render={() => <Helmets />} />
            </header>
            <main className={shouldShowAlertTrial ? 'm-t-30' : ''}>
              <Suspense fallback={<OverlayLoadingSpinner />}>
                {/* Lazy loaded components are rendered with the `render` prop (or if they have a
                    HoC wrapping them, as in `connect`, `withRouter`), otherwise we just use the `component` */}
                <Switch>
                  <Redirect exact from='/' to='/login' />
                  <Route
                    path='/login'
                    render={(props) => <SignIn {...props} />}
                  />
                  <Route
                    exact
                    path='/feedbacks'
                    render={(props) => <NewFeedback {...props} />}
                  />
                  <Route
                    path='/feedbacks/new'
                    render={(props) => <NewFeedback {...props} />}
                  />
                  <Route
                    path='/feedbacks/thankyou'
                    render={(props) => <FeedbackThankYou {...props} />}
                  />
                  <Route
                    path='/test'
                    render={(props) => <AuthFeedback {...props} />}
                  />
                  <Route
                    path='/login'
                    render={(props) => <SignIn {...props} />}
                  />
                  <Route
                    path='/signUp'
                    render={(props) => <SignUp {...props} />}
                  />
                  <Route
                    path='/billingInfo/:businessId/:paymentToken'
                    render={(props) => <BusinessPaymentPage {...props} />}
                  />
                  <Route
                    path='/paymentStatus/:businessId/:clientSecret'
                    render={(props) => <BusinessPaymentStatusPage {...props} />}
                  />
                  <Route
                    path='/start'
                    render={(props) => <SignUpMiddle {...props} />}
                  />
                  <Route
                    path='/contact'
                    render={(props) => <ContactUs {...props} />}
                  />
                  <Route
                    path='/reactivate'
                    render={(props) => <ReactivateBusiness {...props} />}
                  />
                  <Route
                    path='/selectBusiness'
                    render={(props) => <SelectBusiness {...props} />}
                  />
                  <Route
                    path='/forgotPassword'
                    render={(props) => <ForgotPassword {...props} />}
                  />
                  <Route
                    path='/passwordReset'
                    render={(props) => <PasswordReset {...props} />}
                  />
                  <Route exact path='/emails/:id' component={Email} />
                  <Route
                    path='/support'
                    render={(props) => <SupportPage {...props} />}
                  />
                  <Route
                    path='/dashboard'
                    render={(props) => <DashboardPage {...props} />}
                  />
                  <Route
                    path='/tutorials'
                    render={(props) => <TutorialsPage {...props} />}
                  />
                  <Route
                    path='/todos'
                    render={(props) => <NotificationsPage {...props} />}
                  />
                  <Route
                    path='/churn_zero_success_center'
                    render={(props) => (
                      <ChurnZeroSuccessCenterPage {...props} />
                    )}
                  />
                  <Route
                    exact
                    path='/importWizard/upload/:dataType'
                    render={(props) => <ImportWizardUploadPage {...props} />}
                  />
                  <Route
                    exact
                    path='/importWizard/adjust/:dataType'
                    render={(props) => <ImportWizardAdjustPage {...props} />}
                  />
                  <Route
                    exact
                    path='/importWizard/preview/:dataType'
                    render={(props) => <ImportWizardPreviewPage {...props} />}
                  />
                  <Route
                    exact
                    path='/importWizard/done/:dataType'
                    render={(props) => <ImportWizardDonePage {...props} />}
                  />
                  <Route
                    exact
                    path='/importWizard/translate'
                    render={(props) => (
                      <ImportWizardDreamUploadPage {...props} />
                    )}
                  />
                  <Route
                    exact
                    path='/importWizard/translate/:setId'
                    render={(props) => <ImportWizardTranslatePage {...props} />}
                  />
                  <Route
                    exact
                    path='/importWizard'
                    render={(props) => <ImportWizardSelectPage {...props} />}
                  />
                  <Route
                    path='/at-a-glance'
                    render={(props) => <AtAGlancePage {...props} />}
                  />
                  <Route
                    path='/payments'
                    render={(props) => <PaymentsPage {...props} />}
                  />
                  <Route
                    path='/worldpay-response'
                    render={() => (
                      <div>
                        <LoadingSpinner />
                      </div>
                    )}
                  />
                  <Route
                    path='/conversations'
                    render={(props) => <ConversationsMiddle {...props} />}
                  />
                  <Route path='/profile' component={ProfileMiddle} />
                  <Route
                    exact
                    path='/upgrade/:toUpgrade'
                    render={(props) => <UpgradePage {...props} />}
                  />
                  <Route
                    exact
                    path='/upgrade'
                    render={(props) => <UpgradePage {...props} />}
                  />

                  <Route
                    path='/operations'
                    render={(props) => <OperationsPage {...props} />}
                  />
                  <Route
                    path='/services'
                    render={(props) => <StaffPage {...props} />}
                  />
                  <Route
                    path='/services'
                    render={(props) => <ServicesPage {...props} />}
                  />
                  <Route
                    path='/recurrences'
                    render={(props) => <RecurrencesPage {...props} />}
                  />
                  <Route
                    path='/calendars'
                    render={(props) => <CalendarsPage {...props} />}
                  />
                  <Route
                    path='/contacts'
                    render={(props) => <Contacts {...props} />}
                  />
                  <Route
                    path='/inventory/items/:id/multilocation'
                    render={(props) => <ProductMultilocationPage {...props} />}
                  />
                  <Route
                    path='/inventory'
                    render={(props) => <InventoryPage {...props} />}
                  />
                  <Route
                    path='/orders'
                    render={(props) => <EventsPage {...props} />}
                  />
                  <Route
                    path='/admin'
                    render={(props) => <BusinessAdmin {...props} />}
                  />
                  <Route path='/notFound' component={NotFound} />
                  <Route
                    path='/applicationError'
                    component={ApplicationError}
                  />
                  <Route
                    path='/print'
                    render={(props) => <PrintMiddlePage {...props} />}
                  />
                  <Route
                    path='/tg-admin'
                    render={(props) => <Admin {...props} />}
                  />
                  <Route
                    path='/mock-page'
                    render={(props) => <MockPage {...props} />}
                  />
                  <Redirect from='*' to='notFound' />
                </Switch>
              </Suspense>
            </main>
            {routesWithFooter.map((path, index) => (
              <Route key={`footer-${path}`} path={path} component={Footer} />
            ))}
          </div>
        </RouteChangeWrapper>
      </ConnectedRouter>
    );
  }
}
const mapStateToProps = (state) => {
  const { user } = state.auth;
  const { user: adminUser } = state.admin_auth;
  const { alertsTrial, shouldShowAlertTrial } = state.business;
  return { user, adminUser, alertsTrial, shouldShowAlertTrial };
};
export default connect(mapStateToProps, null)(Routes);
